import { NgModule } from '@angular/core'
import { WINDOW } from '../variables'

export function windowFactory() {
  return window
}

@NgModule({
  providers: [{
    provide: WINDOW,
    useFactory: windowFactory
  }]
})
export class WindowModule {}
